import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

const WITHOUT_PATTERN = /^(?!www\.).*$/i;

export function withoutWwwValidator(
  control: FormControl<string | null>,
): { withoutWww: boolean } | null {
  return isEmpty(control.value) || WITHOUT_PATTERN.test(control.value)
    ? null
    : { withoutWww: true };
}
